/**
 * The Default Agency — the Agency Key assumed wherever the client holds a
 * stopId or tripId but no backend-advertised Agency Key to pair with it:
 * Favorites and Active Trips saved before the Agency Key existed, and the
 * Vehicle Entry flow (the vehicle-lookup endpoint emits no Agency Key).
 *
 * Fixed to `lametro-bus` because the bus feed is the only agency the Vehicle
 * Entry flow and pre-Agency-Key records can belong to — see
 * docs/adr/0006-default-agency-for-sourceless-requests.md.
 */
export const DEFAULT_AGENCY = "lametro-bus";

/**
 * Agency Key the backend used for the LA Metro bus feed before renaming it to
 * `lametro-bus` (via-la-api ADR-012). The backend now rejects it with 400.
 * Always means bus: `lametro-rail` was only added after the rename.
 */
const PRE_RENAME_BUS_AGENCY = "lametro";

/**
 * Resolves an Agency Key the client did not just receive from the backend —
 * a persisted Favorite or Active Trip, or an `agency` URL search param that
 * may come from an old link: missing → Default Agency, pre-rename `lametro` →
 * `lametro-bus`.
 */
export function resolveAgencyKey(agency: string | null | undefined): string {
  if (!agency || agency === PRE_RENAME_BUS_AGENCY) {
    return DEFAULT_AGENCY;
  }
  return agency;
}
